import Vue from 'vue'
import Vuex from 'vuex'
import auth from './module/auth'
import category from './module/category'
import store from './module/store'
import itemlist from './module/itemlist'
import detail from './module/detail'
import predict from './module/predict'
import skulist from './module/skulist'
import summary from './module/summary'
import setting from './module/setting'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    category,
    store,
    itemlist,
    detail,
    predict,
    skulist,
    summary,
    setting,
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js